import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import ReactQuill from 'react-quill';
import Select from 'react-select';
import 'react-quill/dist/quill.snow.css';
import './SignatureModal.css';

const modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }],
        ['link', 'image'],
        ['clean']
    ]
};

const formats = ['bold', 'italic', 'underline', 'strike', 'color', 'link', 'image'];

const SignatureModal = ({ isOpen, toggle, signature, firstName: initialFirstName, lastName: initialLastName, salesAccounts, selectedSalesAccounts: initialSelected, onSave, saving }) => {
    const [content, setContent] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [selectedAccounts, setSelectedAccounts] = useState([]);

    const accountOptions = (salesAccounts || []).flatMap(acc => {
        const emailIntegrations = (acc.integrations || []).filter(i =>
            i.tokens?.email || i.accountIdentifier
        );
        if (emailIntegrations.length === 0) {
            return [{ value: acc._id, label: acc.name || acc._id }];
        }
        return emailIntegrations.map(i => ({
            value: `${acc._id}__${i._id}`,
            label: i.tokens?.email || i.accountIdentifier,
            accountId: acc._id,
            accountName: acc.name,
        }));
    });

    useEffect(() => {
        if (isOpen) {
            setContent(signature || '');
            setFirstName(initialFirstName || '');
            setLastName(initialLastName || '');
            const preSelected = (initialSelected || []).map(id =>
                accountOptions.find(opt => opt.value === id)
            ).filter(Boolean);
            setSelectedAccounts(preSelected);
        }
    }, [isOpen, signature, initialFirstName, initialLastName]);

    const handleSave = () => {
        onSave({ content, firstName, lastName, selectedAccounts });
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} className={`main-modal new-user-modal modal-dialog-centered workflow-modal signature-modal`} size="lg">
            <ModalHeader toggle={toggle}><h3>Email Signature</h3></ModalHeader>
            <ModalBody>
                <div className='content-area'>
                    <div className='form-area'>
                        <h5 className='content-area-heading'>Create your email signature. This will be automatically added to emails sent from this sales account.</h5>
                        <div className="signature-name-field signature-accounts-field">
                            <label className="signature-name-label">Sales Accounts</label>
                            <Select
                                isMulti
                                options={accountOptions}
                                value={selectedAccounts}
                                onChange={setSelectedAccounts}
                                placeholder="Select sales accounts..."
                                classNamePrefix="sig-select"
                                className="sig-select-container"
                            />
                        </div>
                        <div className="signature-name-row">
                            <div className="signature-name-field">
                                <label className="signature-name-label">First Name</label>
                                <input
                                    type="text"
                                    className="signature-name-input"
                                    placeholder="First name"
                                    value={firstName}
                                    onChange={e => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className="signature-name-field">
                                <label className="signature-name-label">Last Name</label>
                                <input
                                    type="text"
                                    className="signature-name-input"
                                    placeholder="Last name"
                                    value={lastName}
                                    onChange={e => setLastName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="signature-layout">
                            <div className="signature-editor-section">
                                <div className="signature-editor-container">
                                    <ReactQuill
                                        theme="snow"
                                        value={content}
                                        onChange={setContent}
                                        modules={modules}
                                        formats={formats}
                                        placeholder="Enter your signature..."
                                    />
                                </div>
                            </div>
                            <div className="signature-preview-section">
                                <label className="signature-preview-label">Preview:</label>
                                <div className="signature-preview-content" dangerouslySetInnerHTML={{ __html: content || '<span class="signature-placeholder">Your signature will appear here...</span>' }} />
                            </div>
                        </div>
                        <div className='btns-box text-right'>
                            <button type="button" className='btn-style-border' onClick={toggle}>
                                        Cancel
                                    </button>
                                    <button type="submit" className='btn-style-new' onClick={handleSave} disabled={saving}>
                                        {saving ? 'Saving...' : 'Save Signature'}
                                    </button>
                        </div>
                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export default SignatureModal;
